import React from 'react'
import PropTypes from 'prop-types'

export class GoogleMarker extends React.PureComponent {
  static propTypes = {
    position: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    })
  }

  componentDidMount () {
    const {mapInstance, position, title, icon} = this.props
    this._marker = new window.google.maps.Marker({
      position: position,
      // if mapInstance isn't a rwgps.Map, assume it's a direct reference to the gmap
      map: mapInstance.gmap || mapInstance,
      icon: {
        url: icon.iconUrl,
        scaledSize: new window.google.maps.Size(icon.iconSize[0], icon.iconSize[1]),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(icon.iconAnchor[0], icon.iconAnchor[1]),
        label: title
      }
    })
    // Google maps event listeners don't follow normal patterns, so we need to
    // persist a reference to the event listener handle they return, which
    // exposes a remove() method.
    //
    // Side note: I **love** how every JS framework likes to invent their own
    // version of events and event bubbling. Love it.
    this._clickListener = this._marker.addListener('click', this._onClick)
    this._mouseoverListener = this._marker.addListener('mouseover', this._onMouseOver)
    this._mouseoutListener = this._marker.addListener('mouseout', this._onMouseOut)
  }

  // event proxy callbacks so that event binding & unbinding works even if the
  // props callback function gets changed between mount and unmount
  _onClick = () => {
    this.props.onClick && this.props.onClick()
  }

  _onMouseOver = () => {
    this.props.onMouseOver && this.props.onMouseOver()
  }

  _onMouseOut = () => {
    this.props.onMouseOut && this.props.onMouseOut()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.position !== this.props.position) {
      this._marker.setPosition(this.props.position)
    }
  }

  componentWillUnmount () {
    try {
      this._clickListener.remove()
      this._mouseoverListener.remove()
      this._mouseoutListener.remove()
    } catch (e) {
      console.warn('encountered error cleaning up google marker event listeners', e)
    }
    this._marker.setMap(null)
    delete this._marker
  }

  render () {
    return null
  }
}
